import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { familiesApi, CreateFamilyLinkPayload, InviteSubUserPayload, InviteLookupResponse } from '../api/families';
import { QUERY_KEYS } from '../utils/constants';

export function useDependents(guardianId: string) {
  return useQuery({
    queryKey: [QUERY_KEYS.dependents, guardianId],
    queryFn: () => familiesApi.getDependents(guardianId),
    enabled: !!guardianId,
  });
}

export function useGuardians(athleteId: string) {
  return useQuery({
    queryKey: [QUERY_KEYS.guardians, athleteId],
    queryFn: () => familiesApi.getGuardians(athleteId),
    enabled: !!athleteId,
  });
}

export function useCreateFamilyLink() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateFamilyLinkPayload) => familiesApi.createLink(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.dependents] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.guardians] });
    },
  });
}

export function useInviteSubUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: InviteSubUserPayload) => familiesApi.inviteSubUser(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['familyMemberships'] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.dependents] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.guardians] });
    },
  });
}

export function useLookupInvite(token: string) {
  return useQuery({
    queryKey: ['invite', token],
    queryFn: () => familiesApi.lookupInvite(token),
    enabled: !!token,
  });
}

export function useDeleteFamilyLink() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (linkId: string) => familiesApi.deleteLink(linkId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.dependents] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.guardians] });
    },
  });
}
